/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import { OrderType } from 'commons/types';
import { CompanyState, ICompanyInfo } from 'commons/types/company.interface';
import { ReducerKeys } from 'redux-stores/enums/reducerKey.enum';

const initialState: CompanyState = {
  company: null,
};

const companyInfoSlice = createSlice({
  name: ReducerKeys.PackingTask,
  initialState,
  reducers: {
    setCompanyInfo(
      state: CompanyState,
      action: { type: string; payload: ICompanyInfo },
    ) {
      state.company = action.payload;
    },

    setAPJSignature(
      state: CompanyState,
      action: {
        type: string;
        payload: {
          companyInfo: ICompanyInfo;
          signature: string;
          apjType: OrderType;
        };
      },
    ) {
      state.company = {
        ...action.payload.companyInfo,
        apj: {
          ...action.payload.companyInfo.apj,
          [action.payload.apjType]: {
            ...action.payload.companyInfo.apj[action.payload.apjType],
            signature: action.payload.signature,
          },
        },
      };
    },

    setAPJStampedSignature(
      state: CompanyState,
      action: {
        type: string;
        payload: {
          companyInfo: ICompanyInfo;
          signature: string;
          apjType: OrderType;
        };
      },
    ) {
      state.company = {
        ...action.payload.companyInfo,
        apj: {
          ...action.payload.companyInfo.apj,
          [action.payload.apjType]: {
            ...action.payload.companyInfo.apj[action.payload.apjType],
            stamped_signature: action.payload.signature,
          },
        },
      };
    },
  },
});

export const { setCompanyInfo, setAPJSignature, setAPJStampedSignature } =
  companyInfoSlice.actions;

export default companyInfoSlice.reducer;
